var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar8({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-3 -3 93 93",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1.15) translate(-6 -6)",
    d: "M43.54 8.21        C45.13 8.15, 50.00 18.21, 51.47 18.82        C53.12 19.50, 64.97 16.42, 66.28 17.63        C67.45 18.71, 63.77 29.27, 64.38 30.74        C65.06 32.39, 75.62 38.59, 75.69 40.37        C75.75 41.96, 65.69 46.82, 65.08 48.29        C64.40 49.94, 67.48 61.79, 66.27 63.10        C65.19 64.27, 54.63 60.60, 53.16 61.21        C51.51 61.89, 45.31 72.45, 43.53 72.52        C41.94 72.58, 37.07 62.52, 35.60 61.91        C33.95 61.23, 22.10 64.31, 20.79 63.10        C19.62 62.02, 23.30 51.46, 22.69 49.99        C22.01 48.34, 11.45 42.14, 11.38 40.36        C11.32 38.77, 21.38 33.90, 21.99 32.43        C22.67 30.78, 19.59 18.93, 20.80 17.62        C21.88 16.45, 32.44 20.12, 33.91 19.51        C35.56 18.83, 41.76 8.27, 43.54 8.21        Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar8);
export default __webpack_public_path__ + "static/media/star8.cdd5659e28895847259f795c517db868.svg";
export { ForwardRef as ReactComponent };